export const FETCH_ENDPOINTS_REQUEST = 'ENDPOINTS/FETCH_ENDPOINTS_REQUEST';
export const FETCH_ENDPOINTS_SUCCESS = 'ENDPOINTS/FETCH_ENDPOINTS_SUCCESS';
export const FETCH_ENDPOINTS_FAILURE = 'ENDPOINTS/FETCH_ENDPOINTS_FAILURE';
